import React, {Component, Fragment, useEffect } from "react";
import ReactDOM from "react-dom";
import {Link} from "react-router-dom";

const options = {threshold: 0.1};


class MainPixelogChallengeHeaderCard extends Component {

    componentDidMount() {
        const {dataKey, created_at, type } = this.props;
        let year = created_at.substring(2, 4);
        let month = created_at.substring(5, 7);
        let day = created_at.substring(8, 10);
        let imgSrc;

        // ai 이미지경로
        if (type == '1') {
            imgSrc = `/outputs/txt2img/20${year}-${month}-${day}/${dataKey}.png`;
        } else {
            imgSrc = `/upload/${year}/${month}/${day}/${dataKey}.png`;
        }

        if(imgSrc){
            // 다른 이미지 테스트
            // imgSrc = '/outputs/txt2img/2023-12-20/00023-3901326415.png';

            var image = new Image();
            image.src = imgSrc;
            if (image.complete) {
                handleImageLoad();
            } else {
                image.onload = handleImageLoad;
            }

            function handleImageLoad() {
                var width = image.width;
                var height = image.height;
                var canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                var context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                var imageData = context.getImageData(0, 0, width, height);
                var pixels = imageData.data;
                var totalRed = 0, totalGreen = 0, totalBlue = 0;
                for (var i = 0; i < pixels.length; i += 4) {
                    totalRed += pixels[i];
                    totalGreen += pixels[i + 1];
                    totalBlue += pixels[i + 2];
                }
                var pixelCount = pixels.length / 4;
                var avgRed = Math.round(totalRed / pixelCount);
                var avgGreen = Math.round(totalGreen / pixelCount);
                var avgBlue = Math.round(totalBlue / pixelCount);
                var paddingColor = 'rgb(' + avgRed + ',' + avgGreen + ',' + avgBlue + ')';
                var headerContainer = document.querySelector('.header-container-challenge');
                if (headerContainer !== null) {
                    headerContainer.style.setProperty('background-color', paddingColor);
                }
            }
        }

    }//componentDidMount

    render() {
        const {dataKey, created_at, cnt, ctags, tags, type, challenge_created_at, name,nick,uid } = this.props;
        let year = created_at.substring(2, 4);
        let month = created_at.substring(5, 7);
        let day = created_at.substring(8, 10);
        let imgSrc;

        // ai 이미지경로
        if (type == '1') {
            imgSrc = `/outputs/txt2img/20${year}-${month}-${day}/${dataKey}.png`;
        } else {
            imgSrc = `/upload/${year}/${month}/${day}/${dataKey}.png`;
        }
        // 다른 이미지 테스트
        // imgSrc = '/outputs/txt2img/2023-12-20/00023-3901326415.png';

        return (
            <div className="card-preview-actions-tags"
                 style={{
                     borderRadius: "0px",
                     backgroundImage: 'url('+imgSrc+')',
                     backgroundSize: 'contain',
                     backgroundRepeat: 'no-repeat',
                     backgroundPosition: 'center',
                 }}>
                <div className="card-preview-actions-tags"
                     style={{
                         borderRadius: "0px"
                    }}>
                    <div className="card-preview-contents-tags text-white text-left">
                        <div className="neo neo-contents-tags"
                             style={{
                                 position: "absolute",
                                 bottom: "30px",
                                 right: "10px",
                             }}
                        >By {nick}</div>
                    </div>
                </div>
            </div>
        ); //return
    }
}
export default MainPixelogChallengeHeaderCard;